import { Component, ElementRef, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { DhhpAlertComponent } from 'src/app/shared/dhhpalert/dhhpalert.component';
import { ActivationCodeService } from '../activation-code.service';

@Component({
  selector: 'app-bulk-activation',
  templateUrl: './bulk-activation.component.html',
  styleUrls: ['./bulk-activation.component.scss']
})
export class BulkActivationComponent implements OnInit {

  //TODO: Cleanup this component as it still has old unused codes. 
  constructor(
    private dhhpAlert: DhhpAlertComponent,
    private translate: TranslateService,
    private elementRef: ElementRef,
    private router: Router,
    private route: ActivatedRoute,
    private activationCodeService: ActivationCodeService
  ) { }

  FileUploadStatus: boolean = false
  initialView: boolean = true
  @ViewChild('fileDropRef', { static: false })
  fileDropE1: ElementRef;
  @Output()
  files: any[] = []
  filename
  fileSize
  fileContent: string[] = []
  showProgress: boolean = false
  progress: number
  cancelActive
  progressInterval
  percent: number = 0
  deg: number = 0

  ngOnInit(): void {
  }

  onFileDropped(event) {
    //console.log('onFileDropped : ', event)
    this.files = event
    this.prepareFilesList(this.files)
  }

  fileBrowseHandler(event) {
    //console.log('fileBrowseHandler : ', event)
    this.files = event
    this.prepareFilesList(this.files)
  }

  goBack() {
    // this.fileDropE1.nativeElement.value = ""
    this.FileUploadStatus = false
    // this.showProgress = false
    this.initialView = true
    // console.log('the fileref  :',this.fileDropE1.nativeElement.fileContent)
    // const url = this.router.url
    // this.router.navigateByUrl(url)
    // this.router.navigateByUrl('/administration/patientmgmt/bulk-onboard')
  }

  // Get the correct bytes/KB etc from the file size
  getCorrectSize(bytes, decimal = 2) {
    if (bytes == 0) {
      return '0 Bytes'
    }
    const k = 1024
    const dm = decimal <= 0 ? 0 : decimal
    const sizeArr = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizeArr[i];
  }

  // Upload progress simulator
  uploadFilesSimulator() {
    this.showProgress = true
    setTimeout(() => {
      this.progress = 0
      this.progressInterval = setInterval(() => {
        if (this.progress === 100) {
          //console.log('Progress stopped at percentage :',this.progress)
          this.showBulkList(this.files)
          // this.router.navigate(['new-list/'], { relativeTo: this.route })
          this.cancelActive = true
          clearInterval(this.progressInterval)
        }
        else {
          this.progress += 4
          // circular progress starts
          this.circularFunction(this.progress)
          // circular progress ends
        }
      }, 120)
      // circular progress starts
      // this.circularFunction()
      // circular progress  
    }, 100) //to start the fun inside the setTimeOut only one, after 0 sec
    // console.log('Progress simulator can be shown !!')
  }

  circularFunction(percentage) {
    // this.percent = parseInt(this.elementRef.nativeElement.querySelector('.progress-pie-chart').getAttribute('data-percent'));
    this.deg = 360 * percentage / 100;
    if (percentage > 50) {
      this.elementRef.nativeElement.querySelector('.progress-pie-chart').classList.add('gt-50');
    }
    this.elementRef.nativeElement.querySelector('.ppc-progress-fill').style.transform = 'rotate(' + this.deg + 'deg)';
    this.elementRef.nativeElement.querySelector('.ppc-percents span').innerHTML = percentage + '%';
  }

  loadProceed() {
    this.showProgress = false
    this.uploadFilesSimulator()
  }

  clickedCancel() {
    clearInterval(this.progressInterval)
    this.cancelActive = false
    this.FileUploadStatus = false
    this.router.navigate(['../'], { relativeTo: this.route })
  }

  // function to process received files
  prepareFilesList(files) {
    // show the file name and its byte size, not sending data to service
    try {
      this.FileUploadStatus = true
      let file: File = files[0]
      this.filename = file.name
      this.fileSize = file.size
      if (file.type !== 'text/csv') {
        this.dhhpAlert.dhhpAlertError(this.translate.instant('uploadedFileFormatNotSupported'), '')
        //this.appInsightMonitoringService.logException(this.translate.instant('uploadedFileFormatNotSupported'))
        this.goBack()
      }
      if (files.length > 1) {
        this.dhhpAlert.dhhpAlertError(this.translate.instant('multipleFilesNotSupported'), '')
        //this.appInsightMonitoringService.logException(this.translate.instant('multipleFilesNotSupported'))
        this.goBack()
      }
    }
    catch (error) {
      //this.appInsightMonitoringService.logException(error,3)
      this.goBack()
    }
  }

  // Read content of the file
  readContent(fileList: FileList): Observable<string[]> {
    const sub = new Subject<string[]>();
    let file: File = fileList[0]
    // console.log('IN read the file name is : ',file.name)
    // this.filename = file.name
    // this.fileSize = file.size
    let fileReader: FileReader = new FileReader()
    let self = this
    fileReader.onload = function (x) {
      const content = (fileReader.result.toString().split(/\r?\n|\r|\n/g));
      sub.next(content);
      sub.complete();
    }
    fileReader.readAsText(file)
    return sub.asObservable()
  }

  showBulkList(files) {
    this.FileUploadStatus = true;
    this.readContent(files).subscribe(res => {
      // this.activationCodeService.setData(res);
      this.router.navigate(['new-list/'], { relativeTo: this.route });
    })
  }

  navToHome() {
    this.router.navigate(['../'], { relativeTo: this.route });
  }

}
